<template>
  <section class="stats-section" id="stats-section">
    <div class="container">
     
      <h2 class="section-title">{{ $t('statsSection.title') }}</h2>
      <ul class="points-list">
        <li v-for="(point, index) in $t('statsSection.points')" :key="`point-${index}`">
          {{ point }}
        </li>
      </ul>
      <div class="stats-grid">
        <div class="stat-card" v-for="(stat, index) in $t('statsSection.stats')" :key="`stat-${index}`">
          <p class="stat-value">{{ stat.value }}</p>
          <p class="stat-label">{{ stat.label }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StatsSection'

};
</script>

<style scoped>
.stats-section {
  background-image:  url('~@/assets/major-media-styled/bj.jpg');
  /* background-color: #f4f8ff;  */
  padding: 60px 20px; 
  text-align: center;
}

.container {
  max-width: 960px; /* 内容区域可以窄一些，使其更集中 */
  margin: 0 auto;
}

.section-title {
  font-size: 2.2em;
  color: #c0392b; /* 图片中的红色标题 */
  margin-bottom: 25px; /* 标题和下方要点列表的间距 */
  font-weight: 600;
  letter-spacing: 1px;
}

.points-list {
  list-style: none;
  padding: 0;
  margin: 0 auto 40px auto; /* 列表与下方统计数据的间距 */
  max-width: 700px; /* 限制列表宽度使其更易读 */
  color: #34495e;
  font-size: 1em; /* 根据图片调整 */
  line-height: 1.7;
}

.points-list li {
  margin-bottom: 8px;
}
/* 如果只有一个点，可以移除上面的列表样式，直接用 p 标签 */
/*
.description-point {
  color: #34495e;
  font-size: 1em;
  line-height: 1.7;
  margin-bottom: 8px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
.description-point:last-child {
  margin-bottom: 40px;
}
*/

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); /* 响应式四列 */
  gap: 25px; /* 卡片之间的间距 */
  max-width: 1000px; /* 限制统计卡片区域的总宽度 */
  margin: 0 auto; /* 使其在容器内居中 */
}

.stat-card {
  background-color: #ffffff; /* 白色卡片背景 */
  padding: 30px 15px; /* 卡片内边距 */
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.07); /* 轻微阴影 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 140px; /* 给卡片一个最小高度 */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.stat-value {
  font-size: 2.8em;
  font-weight: bold;
  color: #c0392b; /* 红色数字 */
  margin-bottom: 5px;
  line-height: 1.1; /* 调整行高以更好地容纳 "+" */
}

.stat-label {
  font-size: 1em;
  color: #333; /* 深色标签文字 */
  line-height: 1.4;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr); /* 中等屏幕上变为2列 */
  }
}

@media (max-width: 768px) {
  .section-title {
    font-size: 2em;
  }
  .points-list {
    font-size: 0.95em;
  }
   .stat-value {
    font-size: 2.5em;
  }
  .stat-label {
    font-size: 0.95em;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr); /* 在非常小的屏幕上也保持两列，如果希望单列则改为 1fr */
    gap: 15px;
  }
  .stat-card {
    min-height: 120px;
    padding: 20px 10px;
  }
  .stat-value {
    font-size: 2.2em;
  }
}
</style>